import { __makeTemplateObject } from "tslib";
import styled from '@marvelapp/styled';
import Box from './Box';
var Grid = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n"], ["\n  display: grid;\n"])));
export default Grid;
var templateObject_1;
